
export enum EmployeeIdTypeCd {
	RACF_ID = 'RACFId'}

